import { configureStore, combineReducers, AnyAction } from "@reduxjs/toolkit";
import storage from "./storage";
import { persistReducer, persistStore } from "redux-persist";
import loginReducer from "./features/login/loginSlice";
import loaderReducer from "./features/loader/loaderSlice";
import filterReducer from "./features/filter/filterSlice";
import buyFilterReducer from "./features/buyFilterPayload/buyFilterPayload";
import propertiesReducer from "./features/properties/propertiesSlice";
import sellPropertiesReducer from "./features/sell/sellSlice";
import modalStateReducer from "./features/modalState/modalSlice";
import propertyHistoryReducer from "./features/propertyHistory/propertyHistory";
import notificationReducer from "./features/notification/notificationSlice";
import registerReducer from "./features/register/registerSlice";
import notFoundReducer from "./features/not-found/notFoundSlice";

const RESET_STORE = "RESET_STORE";

const appReducer = combineReducers({
  login: loginReducer,
  loader: loaderReducer,
  filter: filterReducer,
  buyFilterPayload: buyFilterReducer,
  properties: propertiesReducer,
  sellProperties: sellPropertiesReducer,
  modalState: modalStateReducer,
  propertyHistory: propertyHistoryReducer,
  notification: notificationReducer,
  register: registerReducer,
  notFound: notFoundReducer,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction
) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "login",
    "filter",
    "buyFilterPayload",
    "properties",
    "sellProperties",
    "propertyHistory",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const makeStore = () => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST", RESET_STORE],
        },
      }),
  });
};

const store = makeStore();
export const persistor = persistStore(store);

export default store;
export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
export const resetStore = () => ({ type: RESET_STORE });
